// Proteus -- OpenAI Conversions API: oppref capture + persistence
//
// Purpose: When a user arrives from an OpenAI ad, the inbound URL carries an
// `oppref` query parameter. We capture it, persist it for the attribution
// window, and attach it to the cart so it lands on the resulting order as a
// note_attribute. Shopify Flow then reads that attribute and fires the
// server-side conversion event to OpenAI's Conversions API.
//
// Companion: assets/proteus-utils.js (uses proteus.add_cartAttributes)

(function () {
  "use strict";

  const STORAGE_KEY = "kizik_oppref";
  const TTL_DAYS = 7;                  // OpenAI attribution window
  const TTL_MS = TTL_DAYS * 24 * 60 * 60 * 1000;

  // 1) Read oppref from URL (if present on this pageview)
  let oppref = null;
  try {
    const params = new URLSearchParams(window.location.search);
    oppref = params.get("oppref");
  } catch (e) {
    // URLSearchParams unsupported on this browser — bail silently
    return;
  }

  // 2) If URL has fresh oppref, persist it (overwrites any prior value)
  if (oppref) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ value: oppref, ts: Date.now() })
      );
    } catch (e) {
      // localStorage may be blocked in private mode — ignore
    }
  }

  // 3) Read whatever is currently stored (fresh or from a prior visit)
  let stored = null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) stored = JSON.parse(raw);
  } catch (e) {
    return;
  }

  if (!stored || !stored.value || !stored.ts) return;

  // 4) Expire if older than TTL
  if (Date.now() - stored.ts > TTL_MS) {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    return;
  }

  // 5) Write to cart attributes via the existing proteus helper.
  // proteus-utils.js is loaded just above this in theme.liquid, so the helper
  // is guaranteed available. The helper is debounced (~2.5s), de-duped, and
  // handles the /cart/update.js POST under the hood.
  //
  // The plural add_cartAttributes() helper expects pre-formatted strings in
  // Shopify's cart-update format: attributes[KEY]=VALUE (the singular helper
  // wraps the key for you; the plural does not).
  if (window.proteus && typeof window.proteus.add_cartAttributes === "function") {
    window.proteus.add_cartAttributes([
      "attributes[oppref]=" + encodeURIComponent(stored.value),
    ]);
  }
})();
